var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.734,
    height: 7.259,
    viewBox: "0 0 12.734 7.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate_1_",
    "data-name": "arrow-down-sign-to-navigate (1)",
    transform: "translate(12.734 7.259) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M6.367,7.259A.889.889,0,0,1,5.737,7L.261,1.522A.892.892,0,0,1,1.522.261L6.367,5.106,11.212.261a.892.892,0,0,1,1.261,1.261L7,7A.889.889,0,0,1,6.367,7.259Z",
    transform: "translate(12.734 7.259) rotate(180)",
    fill: "#4397d2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.341fe2e5491a70f78f7bc8823abfe81b.svg";
export { ForwardRef as ReactComponent };